import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolGroupModifyRequest } from "../../../services/SchoolGroupModifyRequest";
import { StringRequest } from "../../../services/StringRequest";
import { SysAdminService } from "../../../services/sysadmin.service";

@Component({
	selector: "app-manage-sctadd",
	templateUrl: "./manage-sctadd.component.html",
	styleUrls: ["./manage-sctadd.component.css"],
})
export class ManageSCTAddComponent implements OnInit {
	constructor(private ref: DynamicDialogRef, private sysAdminService: SysAdminService, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {}

	///////////////////////////////////
	// Data
	///////////////////////////////////

	Code: any = "";
	Name: any = "";

	errorMessage: any = "";

	///////////////////////////////////

	///////////////////////////////////
	// Buttons
	///////////////////////////////////
	onUpdate() {
		this.errorMessage = "";

		//Error handling
		if (this.Code == undefined || this.Code == "") {
			this.errorMessage = "Enter a Code";
			return;
		}

		if (this.Code.length < 3) {
			this.errorMessage = "Code must be at least 3 characters";
			return;
		}

		if (this.Name == undefined || this.Name == "") {
			this.errorMessage = "Enter a Description";
			return;
		}

		if (this.Name.length < 3) {
			this.errorMessage = "Description must be at least 3 characters";
			return;
		}

		//Code and Description must be unique
		this.CheckCode();
	}

	CheckCode() {
		let parms: StringRequest = {
			str: this.Code,
		};

		var result = this.sysAdminService.SchoolGroupCodeInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Code already in use";
					return;
				} else {
					this.CheckDesc();
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: StringRequest = {
			str: this.Name,
		};

		var result = this.sysAdminService.SchoolGroupDescInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Description already in use";
					return;
				} else {
					this.CreateSchoolGroup();
				}
			},
			(error) => {}
		);
	}

	CreateSchoolGroup() {
		let parms: SchoolGroupModifyRequest = {
			SchoolGroupID: -1,
			Code: this.Code,
			Desc: this.Name,
		};

		var result = this.sysAdminService.SchoolGroupModify(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School Container was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not create the School Container",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////
}
